import React, { Fragment, useState } from "react";
import Header from "../components/layout/Header";
import Modal from "../components/general/Modal";
import FancyToggle from "../components/general/inputs/FancyToggle";
import classes from "./Layout.module.css";
import VideoButton from "../components/general/VideoButton";
import AcknowledgeVideo from "../assests/videos/1_Acknowledge.mp4";

const Layout = ({ children }) => {
  const [showModal, setShowModal] = useState(true);
  const [hasAgreed, setHasAgreed] = useState(false);

  const closeModalHandler = () => {
    if (hasAgreed) {
      setShowModal(false);
    }
  };

  return (
    <Fragment>
      <Header />
      <main>{children}</main>
      {showModal && (
        <Modal
          modalHandler={closeModalHandler}
          allowClose={hasAgreed}
          buttonText={"Continue to Partial Retirement Illustrator"}
        >
          <div className={classes.disclaimer}>
            <h1> Disclaimer</h1>
            <h2>
              {" "}
              Partial Retirement Remedy Benefits Illustrator - Please Read{" "}
            </h2>
            <p>
              Welcome to the Northern Ireland Civil Service Pension Scheme 
              Partial Retirement Remedy Benefits Illustrator.
              Please read these terms of service before using the illustrator.
              This illustrator is for guidance and illustration purposes only.{" "}
              <span style={{ fontWeight: "bold" }}>
                {" "}
                The figures shown are not a partial retirement benefit offer{" "}
              </span>
              and are designed to illustrate your basic service benefits only.
              The illustrator is not intended to provide you with financial
              advice. If you require financial advice, you should contact an
              independent financial adviser.
            </p>
            <p> The assumptions we have used in this illustrator are: </p>

            <table>
              <tbody>
                <tr>
                  <td>Future inflation</td>
                  <td>2% per year</td>
                </tr>
              </tbody>
            </table>

            <p>
              {" "}
              Actual revaluation rates for Career Average Revalued Earnings
              (CARE) schemes are applied in the calculator up to and including
              the latest available rate. Thereafter, future CARE revaluation,
              and pension increases, are assumed to be in line with CPI and at
              2% each year.
            </p>
            <p>
              Users can set their own future salary increases between -2% and 3%
              in excess of inflation. For future salary increases, in nominal
              terms, this would be 0% and 5% (i.e. after allowing for 2% assumed
              CPI inflation). If users do not enter a salary as at 1 April 2015
              on the “Your Details” page, salaries between 2015 and current date
              are estimated using high level historical salary increase assumptions.
            </p>
            <p style={{ fontWeight: "bold" }}>
              {" "}
              We do not accept any liability for actions taken by members with
              regards to these illustrations
            </p>
            <VideoButton videoTitle="Disclaimer" video={AcknowledgeVideo} />
            <div className={classes.checkbox_container}>
              <FancyToggle
                state={hasAgreed}
                handleChange={() => setHasAgreed(!hasAgreed)}
              />
              <p
                style={{
                  fontWeight: hasAgreed ? "700" : "500",
                  color: hasAgreed ? "black" : "var(--text-color-light)",
                }}
              >
                {" "}
                I acknowledge that I have read, agree and understand the terms
                of service
              </p>
            </div>
          </div>
        </Modal>
      )}
    </Fragment>
  );
};

export default Layout;
